module.exports = __webpack_public_path__ + "static/media/dimentha-intro.c88df65e.svg";